import { z } from 'zod';
export const PersonalSearchQuerySchema = z.object({
    q: z.string().min(1).max(200),
    limit: z.coerce.number().int().min(1).max(50).optional().default(15),
});
export const SearchResultTypeSchema = z.enum([
    'course',
    'module',
    'topic',
    'lesson',
    'personal_lesson',
]);
export const SearchResultSchema = z.object({
    type: SearchResultTypeSchema,
    id: z.string(),
    title: z.string(),
    breadcrumb: z.array(z.string()),
    deepLink: z.string(),
    relevanceScore: z.number(),
    meta: z
        .object({
        progress: z.number().optional(),
        lessonCount: z.number().optional(),
        stepCount: z.number().optional(),
    })
        .optional(),
});
export const PersonalSearchResponseSchema = z.object({
    results: z.array(SearchResultSchema),
});
//# sourceMappingURL=search.schema.js.map